( function( $ ) {
    "use strict";

    var _events = {
        onFocus: function() {
            var $this = $(this);

            $this.data('inputnav.old-value', $this.val());
        },

        onChange: function(ev) {
            ev.preventDefault();
            ev.stopImmediatePropagation();

            var $this = $(this),
                $inputTarget = $this.prop('tagName') === 'SELECT' ? $this.find(':selected') : $this,
                urlFormat = $(this).data('inputnav'),
                url = urlFormat ? urlFormat.replace(/__VALUE__/g, $this.val()) : $this.val(),
                target = $inputTarget.attr('data-inputnav-target') ? $inputTarget.attr('data-inputnav-target') : '';

            if ($this.is('[data-ajax-link]')) {
                return window.location.ajax(url);
            }

            if (target.toLowerCase() === '_blank') {
                $this.val($this.data('inputnav.old-value'));
                window.open(url);
            } else {
                $this.trigger('forcus.inputnav');
                window.location.assign(url);
            }
        }
    };

    var $body = $('body');

    $body.on('app.init', function(ev) {
        var $container = $(ev.container),
            $inputNavs = $container.find('[data-inputnav]');

        $inputNavs
            .on('focus.inputnav', _events.onFocus)
            .on('change.inputnav', _events.onChange);
    });

}( jQuery ));
